import React, { memo, useCallback, useMemo, useState } from 'react'
import tw from 'twin.macro'
import { ProductsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { CircularProgress, Modal } from '@mui/material'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getMCCustomers } from 'src/selectors/mc'
import { ManageableCustomer } from './ManageableCustomer'
import { FetchMCCustomers } from 'src/constants/actionTypes'

interface Props {
  isManageCustomersOpen: boolean
  openManageCustomers(): void
  closeManageCustomers(): void
}

const ManageCustomersComponent = ({
  isManageCustomersOpen,
  openManageCustomers,
  closeManageCustomers,
}: Props) => {
  const dispatch = useDispatch()

  const mcCustomers = useSelector(getMCCustomers)

  const [isLoading, setIsLoading] = useState(false)

  const container = useMemo(() => document.getElementById('root'), [])

  const fetchMCCustomers = useCallback(() => {
    setIsLoading(true)

    try {
      dispatch(FetchMCCustomers.request())
    } finally {
      setIsLoading(false)
    }
  }, [])

  const refreshMCCustomers = useCallback(() => {
    fetchMCCustomers()
  }, [fetchMCCustomers])

  return (
    <>
      <Button
        className={tw`mr-2`}
        color="white"
        size="small"
        leftIcon={<ProductsMinor width={20} />}
        onClick={openManageCustomers}
      >
        Manage customers
      </Button>
      <Modal
        container={container}
        open={Boolean(isManageCustomersOpen)}
        onClose={closeManageCustomers}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        css={tw`flex flex-row w-full h-full`}
      >
        <div css={tw`bg-white w-[400px] overflow-hidden max-h-full flex flex-col`}>
          <ModalHeader title="Manage customers" onClose={closeManageCustomers} />
          <div css={tw`relative flex flex-col h-full bg-white`}>
            <div css={tw`px-4 flex-1 overflow-auto pb-[96px]`}>
              {isLoading || !mcCustomers ? (
                <div css={tw`flex items-center justify-center h-full`}>
                  <CircularProgress />
                </div>
              ) : (
                mcCustomers.map((item) => (
                  <ManageableCustomer
                    customer={item}
                    key={item.id}
                    refreshMCCustomers={refreshMCCustomers}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export const ManageCustomers = memo(ManageCustomersComponent)
